import { ItemApiDto, PackageProductApiDto, QuoteApiDto, QuoteDiscountsApiDto, QuoteProductApiDto } from '@lx/shared/api/models';
import { QuoteInput } from './quote-input.model';

export const ProductType = QuoteProductApiDto.ClassificationEnum;
export type ProductType = QuoteProductApiDto.ClassificationEnum;
export const TransferTypeEnum = QuoteProductApiDto.TransferServiceTypeEnum;
export type TransferType = QuoteProductApiDto.TransferServiceTypeEnum;

export type QuoteOutputApi = QuoteApiDto;
export type QuoteOutput = QuoteApiDto & { input?: QuoteInput };
export type QuoteProduct = QuoteProductApiDto;
export type PackageProduct = PackageProductApiDto;
export type QuoteDiscounts = QuoteDiscountsApiDto;

export type QuoteOutputItem = ItemApiDto;
